export var RouteUrls = {
  Sms: {
    SendSms: "SendSms"
  },
  CandidateList: {
    CandidateProfile: "CandidateList/Profile",
    JobDetail: "/CandidateList/JobDetail",
    InterViewDetail:"Interviews/InterViewDetail",
    JobList: "/CandidateList/List"
  },
  TalentPool: {
    CandidateDetail: "TalentPool/CandidateDetail",
  },

  Notification: {
    List:"/Notification/List"
  },
  DashBoard: {
    Home:"/Home"
  }
}
 
